import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import { usePermission } from "@backstage/plugin-permission-react";
import { Link } from "@backstage/core-components";
import {
  Permission,
  ResourcePermission,
} from "@backstage/plugin-permission-common";
import { useRootStyles } from "../../styles/useRootStyles";

interface PermissionNavItemProps {
  to: string;
  icon: React.ComponentType<any>;
  label: string;
  permission: Exclude<Permission, ResourcePermission>;
  mobile?: boolean;
  onClick?: () => void;
}

export const PermissionNavItem = ({
  to,
  icon: Icon,
  label,
  permission,
  mobile = false,
  onClick,
}: PermissionNavItemProps) => {
  const classes = useRootStyles();
  const { loading, allowed } = usePermission({ permission });

  if (loading || !allowed) {
    return null;
  }

  if (mobile) {
    return (
      <ListItem
        button
        component={Link}
        to={to}
        className={classes.drawerItem}
        onClick={onClick}
      >
        <ListItemIcon className={classes.drawerIcon}>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={label} />
      </ListItem>
    );
  }

  // Check if used in a dropdown menu (has onClick but not mobile)
  if (onClick) {
    return (
      <MenuItem component={Link} to={to} onClick={onClick}>
        <ListItemIcon>
          <Icon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    );
  }

  return (
    <Button
      component={Link}
      to={to}
      className={classes.navButton}
      startIcon={<Icon />}
      color="inherit"
    >
      {label}
    </Button>
  );
};
